module.exports = __webpack_public_path__ + "img/wallet_icon.15ddddff.svg";